<template>
  <div id="app">
    <RwHeader />
    <router-view />
    <RwFooter />
  </div>
</template>

<script>
import RwHeader from "@/components/Header.vue";
import RwFooter from "@/components/Footer.vue";

export default {
  name: "App",

  components: {
    RwHeader,
    RwFooter
  },

  data: () => ({
    //
  })
};
</script>
